var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYearsCompletionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.476,
    height: 30.504,
    viewBox: "0 0 30.476 30.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ass",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M30.734,43.8H3.741A1.743,1.743,0,0,1,2,42.053V22.436A.436.436,0,0,1,2.435,22h29.6a.436.436,0,0,1,.435.436V42.053A1.743,1.743,0,0,1,30.734,43.8ZM2.871,22.872V42.053a.871.871,0,0,0,.871.872H30.734a.871.871,0,0,0,.871-.872V22.872Z",
    transform: "translate(0 -11.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4747",
    "data-name": "Path 4747",
    d: "M32.04,14.966H2.435A.435.435,0,0,1,2,14.53V9.741A1.741,1.741,0,0,1,3.741,8H7.66a.435.435,0,0,1,0,.871H3.741a.871.871,0,0,0-.871.871V14.1H31.6V9.741a.871.871,0,0,0-.871-.871H26.816a.435.435,0,1,1,0-.871h3.918a1.741,1.741,0,0,1,1.741,1.741V14.53A.435.435,0,0,1,32.04,14.966Z",
    transform: "translate(0 -3.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M34.367,8.871H20.435a.435.435,0,0,1,0-.871H34.367a.435.435,0,1,1,0,.871Z",
    transform: "translate(-10.163 -3.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    d: "M53.741,7.851A1.741,1.741,0,0,1,52,6.11V3.741a1.741,1.741,0,0,1,3.483,0V6.11A1.741,1.741,0,0,1,53.741,7.851Zm0-4.981a.871.871,0,0,0-.871.871V6.11a.871.871,0,1,0,1.741,0V3.741a.871.871,0,0,0-.871-.871Z",
    transform: "translate(-28.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M15.741,7.851A1.741,1.741,0,0,1,14,6.11V3.741a1.741,1.741,0,0,1,3.483,0V6.11A1.741,1.741,0,0,1,15.741,7.851Zm0-4.981a.871.871,0,0,0-.871.871V6.11a.871.871,0,1,0,1.741,0V3.741a.871.871,0,0,0-.871-.871Z",
    transform: "translate(-6.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M56.969,33.909H54.731a.871.871,0,0,1-.871-.871V30.8a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,56.969,33.909ZM54.731,30.8v2.238h2.238V30.8Z",
    transform: "translate(-29.282 -15.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M42.679,33.909H40.441a.871.871,0,0,1-.871-.871V30.8a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,42.679,33.909ZM40.441,30.8v2.238h2.238V30.8Z",
    transform: "translate(-21.213 -15.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M28.4,33.909H26.161a.871.871,0,0,1-.871-.871V30.8a.871.871,0,0,1,.871-.871H28.4a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,28.4,33.909ZM26.161,30.8v2.238H28.4V30.8Z",
    transform: "translate(-13.15 -15.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M56.969,46.409H54.731a.871.871,0,0,1-.871-.871V43.3a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,56.969,46.409ZM54.731,43.3v2.238h2.238V43.3Z",
    transform: "translate(-29.282 -22.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M42.679,46.409H40.441a.871.871,0,0,1-.871-.871V43.3a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,42.679,46.409ZM40.441,43.3v2.238h2.238V43.3Z",
    transform: "translate(-21.213 -22.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M28.4,46.409H26.161a.871.871,0,0,1-.871-.871V43.3a.871.871,0,0,1,.871-.871H28.4a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,28.4,46.409ZM26.161,43.3v2.238H28.4V43.3Z",
    transform: "translate(-13.15 -22.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M14.109,46.409H11.871A.871.871,0,0,1,11,45.539V43.3a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,14.109,46.409ZM11.871,43.3v2.238h2.238V43.3Z",
    transform: "translate(-5.082 -22.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M42.679,58.909H40.441a.871.871,0,0,1-.871-.871V55.8a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,42.679,58.909ZM40.441,55.8v2.238h2.238V55.8Z",
    transform: "translate(-21.213 -29.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M28.4,58.909H26.161a.871.871,0,0,1-.871-.871V55.8a.871.871,0,0,1,.871-.871H28.4a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,28.4,58.909ZM26.161,55.8v2.238H28.4V55.8Z",
    transform: "translate(-13.15 -29.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M14.109,58.909H11.871A.871.871,0,0,1,11,58.039V55.8a.871.871,0,0,1,.871-.871h2.238a.871.871,0,0,1,.871.871v2.238A.871.871,0,0,1,14.109,58.909ZM11.871,55.8v2.238h2.238V55.8Z",
    transform: "translate(-5.082 -29.858)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearsCompletionIcon);
export default __webpack_public_path__ + "static/media/years-completion-icon.ba9f728be6cb56c5225ee5ebd6503193.svg";
export { ForwardRef as ReactComponent };